import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { editBank } from "../../../services/api";

// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogTitle from '@material-ui/core/DialogTitle';
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import { getBanks } from "./../../../services/api";
import { useDispatch } from "react-redux";
import { setSearchBanks } from "../../../store/dataFromBESlice";
import { useHistory } from "react-router-dom";

const EditBank = () => {
  // const [open, setOpen] = useState(false);
  // setOpen(true);
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const [editedBank, setEditBank] = useState({ code: "", vi_name: "", en_name: "", vi_address: "", en_address: "", cif: "", account_number: "" });
  const location = useLocation();
  const { bankid } = useParams();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (location.state) {
      setEditBank({
        code: location.state.code,
        vi_name: location.state.vi_name,
        en_name: location.state.en_name,
        vi_address: location.state.vi_address,
        en_address: location.state.en_address,
        cif: location.state.cif,
        account_number: location.state.account_number,
      });
    }
  }, [location]);

  const handleCode = (e) => {
    setEditBank({ ...editedBank, code: e.target.value });
  };

  const handleViName = (e) => {
    setEditBank({ ...editedBank, vi_name: e.target.value });
  };

  const handleEnName = (e) => {
    setEditBank({ ...editedBank, en_name: e.target.value });
  };

  const handleViAddress = (e) => {
    setEditBank({ ...editedBank, vi_address: e.target.value });
  };

  const handleEnAddress = (e) => {
    setEditBank({ ...editedBank, en_address: e.target.value });
  };

  const handleCif = (e) => {
    setEditBank({ ...editedBank, cif: e.target.value });
  };

  const handleAccountNumber = (e) => {
    setEditBank({ ...editedBank, account_number: e.target.value });
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiTextField-root": {
        margin: theme.spacing(5),
        width: "full",
        display: "flex",
        alignItems: "left",
      },
    },
  }));

  const handleEditBank = () => {
    editBank(bankid, editedBank).then((res) => {
      enqueueSnackbar(res.message, { variant: res.code === 200 ? "success" : "" });
      getBanks().then((res) => dispatch(setSearchBanks(res.data)));
      res.code === 200 && history.push("/banks");
    });
  };

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root} noValidate autoComplete="off">
        <div>
          <div>
            <h1>{t("Chỉnh sửa thông tin ngân hàng")}</h1>
            <div>
              <TextField id="code-bank" label={t("Mã số")} alignItems="left" onChange={handleCode} value={editedBank.code} />
            </div>
            <div>
              <TextField id="vi-name-bank" label={t("Tên ngân hàng (VN)")} alignItems="left" onChange={handleViName} value={editedBank.vi_name} />
            </div>
            <div>
              <TextField id="en-name-bank" label={t("Tên ngân hàng (English)")} alignItems="left" onChange={handleEnName} value={editedBank.en_name} />
            </div>
            <div>
              <TextField id="vi-address-bank" label={t("Địa chỉ(VN)")} alignItems="left" onChange={handleViAddress} value={editedBank.vi_address} />
            </div>
            <div>
              <TextField id="en-address-bank" label={t("Địa chỉ (English)")} alignItems="left" onChange={handleEnAddress} value={editedBank.en_address} />
            </div>
            <div>
              <TextField id="cif-bank" label={t("CIF")} alignItems="left" onChange={handleCif} value={editedBank.cif} />
            </div>
            <div>
              <TextField id="account-number-bank" label={t("Số tài khoản")} alignItems="left" onChange={handleAccountNumber} value={editedBank.account_number} />
            </div>
          </div>
          <Button color="secondary" variant="contained" onClick={() => history.push("/banks")} style={{ margin: 5 }}>
            {t("back")}
          </Button>
          <Button variant="contained" onClick={handleEditBank} style={{ margin: 5 }}>
            {t("save")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditBank;
